import { Link } from "gatsby";
import { GatsbyImage } from "gatsby-plugin-image";
import React from "react";
import CustomLink from "../common/Link";

const CaseStudySection = ({ data }) => {
  return (
    <section className="py-16 md:py-24 xl:py-32 bg-slate-100">
      <div className="mx-auto px-5 md:px-8 lg:px-12">
        {/* Header */}
        <div className="mb-12 lg:mb-16">
          {data.caption && (
            <span className="inline-block text-logo1 text-sm font-medium uppercase tracking-wider mb-4">
              {data.caption}
            </span>
          )}
          <h2 className="text-4xl md:text-5xl lg:text-6xl xl:text-7xl font-bold text-black leading-tight">
            {data.title}
          </h2>
        </div>

        {/* Case Studies Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-12">
          {data.caseStudies.map((casestudy, key) => (
            <article
              key={key}
              className="group border border-gray-200 flex flex-col bg-white relative rounded-xl overflow-hidden shadow-sm hover:shadow-xl transition-all duration-300 transform hover:-translate-y-2"
            >
              <div className="w-full relative overflow-hidden">
                <GatsbyImage
                  image={casestudy.image.image.asset.gatsbyImageData}
                  alt={casestudy.image.altText}
                  className="w-full h-full aspect-[16/11] group-hover:scale-105 transition-transform duration-500"
                />
                {/* Overlay on hover */}
                <div className="absolute inset-0 bg-gradient-to-t from-black/30 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
              </div>

              <div className="p-6 relative flex-1 flex flex-col">
                <h3 className="mb-3 text-2xl font-bold text-black group-hover:text-gray-800 transition-colors duration-200 leading-tight flex-1">
                  <Link to={`/casestudy/${casestudy.casestudyslug.current}`}>
                    <span className="absolute inset-0"></span>
                    {casestudy.heading}
                  </Link>
                </h3>
                <p className="text-gray-600 leading-relaxed line-clamp-3 mb-4 text-lg">
                  {casestudy.description}
                </p>

                {/* Read More Indicator */}
                <div className="flex items-center opacity-0 group-hover:opacity-100 transition-all duration-200 transform translate-y-2 group-hover:translate-y-0">
                  <span className="text-base font-medium text-logo1">
                    View Case Study
                  </span>
                  <svg
                    className="ml-2 w-4 h-4 text-logo1 transform group-hover:translate-x-1 transition-transform duration-200"
                    fill="currentColor"
                    viewBox="0 0 20 20"
                  >
                    <path
                      fillRule="evenodd"
                      d="M10.293 3.293a1 1 0 011.414 0l6 6a1 1 0 010 1.414l-6 6a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-4.293-4.293a1 1 0 010-1.414z"
                      clipRule="evenodd"
                    />
                  </svg>
                </div>
              </div>
            </article>
          ))}
        </div>

        {/* Call to Action Button */}
        {data?.enableButton && (
          <div className="text-center">
            <CustomLink
              cls="inline-flex items-center px-6 py-3 bg-logo1 text-white hover:text-black font-medium rounded-lg hover:bg-[#EFEFEF] transition-all duration-200 transform hover:scale-105 shadow-sm hover:shadow-md"
              data={data.button}
            >
              <span className="font-medium tracking-wider uppercase text-sm">
                {data.button?.buttonText}
              </span>
              <svg
                className="ml-2 w-5 h-5"
                fill="currentColor"
                viewBox="0 0 20 20"
              >
                <path
                  fillRule="evenodd"
                  d="M10.293 3.293a1 1 0 011.414 0l6 6a1 1 0 010 1.414l-6 6a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-4.293-4.293a1 1 0 010-1.414z"
                  clipRule="evenodd"
                />
              </svg>
            </CustomLink>
          </div>
        )}
      </div>
    </section>
  );
};

export default CaseStudySection;
